import { SectionList } from "../components/sections";
import React, { Fragment } from "react";
export const Dubai = () => (
  <Fragment>
    <SectionList place="Dubai"></SectionList>
  </Fragment>
);
